export const CONTACT_SUPPORT_URL = "https://support.fishtracking.innovasea.com/s/contactsupport";

// Criteria source is uncertain, 4 seconds/day came from ticket SF-1116
export const DRIFT_RATE_THRESHOLD = 4;
